import _ from 'lodash';
import moment from 'moment';
import React, { useContext } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import tinyColor from 'tinycolor2';
import DealContext from '../DealContext';
import SimpleQuoteBadge from '../SimpleQuoteBadge';

const HistoryCard = () => {
  const { quoteHistory, quoteList, states, presentQuote } = useContext(DealContext);

  const statusLookup = _.keyBy(states, 'id');

  return (
    <Card className="quote-history-card">
      <Card.Body className="pb-0">
        <Card.Title>Latest Changes</Card.Title>
      </Card.Body>
      {quoteHistory.length === 0 && (
        <div style={{ padding: '0px 20px 20px 20px' }}>
          <i>Any changes to quote data or status will appear here.</i>
        </div>
      )}
      <ListGroup variant="flush">
        {quoteHistory.map(item => {
          const quote = quoteList.find(q => item.quoteId === q.id);

          let extra;
          if (states && item.attributeName === 'Status') {
            const oldState = statusLookup[item.attributeOldValue];
            const newState = statusLookup[item.attributeNewValue];

            extra = (
              <div>
                {oldState && (
                  <span
                    className="old p-1 mr-1"
                    style={{
                      backgroundColor: oldState.color,
                      color: tinyColor(oldState.color).isDark() ? '#fff' : '#333',
                    }}
                  >
                    {oldState ? oldState.name : item.attributeOldValue}
                  </span>
                )}
                {oldState && <i className="fas fa-arrow-alt-right change-arrow mr-1" />}
                {newState && (
                  <span
                    className="new p-1"
                    style={{
                      backgroundColor: newState.color,
                      color: tinyColor(newState.color).isDark() ? '#fff' : '#333',
                    }}
                  >
                    {newState ? newState.name : item.attributeNewValue}
                  </span>
                )}
              </div>
            );
          }

          if (item.attributeName === 'Unit') {
            extra = (
              <div>
                <span className="old unit p-1 mr-1">{item.attributeOldValue}</span>
                {item.attributeOldValue && <i className="fas fa-arrow-alt-right change-arrow mr-1" />}
                <span className="new unit p-1 mr-1">{item.attributeNewValue}</span>
              </div>
            );
          }

          return (
            <ListGroup.Item key={item.id} style={{ borderBottom: '1px solid #ccc' }}>
              <h5 className="float-right">
                <SimpleQuoteBadge quote={quote} onClick={() => presentQuote(item.quoteId)} />
              </h5>
              {item.attributeName} changed
              {extra}
              <small>{item.note}</small>
              <div className="footer-date-user mt-1">
                <small>{moment(new Date(item.createdAt)).fromNow()}</small>
                <small>{item.authorName}</small>
              </div>
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </Card>
  );
};

export default HistoryCard;
